 <div class="max-w-md mx-auto border max-w-md mt-20 rounded mb-20 border-2 border-purple-700 shadow-lg shadow-purple-400">
    <label class="flex justify-center text-xl font-bold">Otp Verification</label>
    <form class="shadow-md  py-6 xs:px-2" >
    
      <div class="lg:mx-6 ml-3 ">
        <ng-otp-input  #ngOtpInput (onInputChange)="onOtpChange($event)"  [config]="config" class="m-2" ></ng-otp-input> <!-- i use *ngIf="showOtpComponent" -->
    </div>
            
            
            <div class="flex items-center justify-center">
                <button class="bg-purple-500 hover:bg-purple-900 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" (click)="verifyOtp()">
                    Verify
                </button>
                <a class="inline-block align-baseline font-bold text-sm text-purple-500 hover:text-purple-800 ml-4" (click)="resendOtp()"  >
                    Resend OTP
                </a>
                <!-- <p *ngIf="verificationMessage">{{ verificationMessage }}</p> -->
            </div>
        </form>
    </div> 
    
        <!--
            <input class="w-12 lg:m-2  h-12 text-center border rounded-md shadow-sm  border-purple-700 ring-border-purple-700" type="tel"  #otp1  formControlName="one"
                    (keyup)="moveFocus($event,otp2,'')" maxlength="1" pattern="[0-9]"  autocomplete="one-time-code" required>
            <input class="w-12 lg:m-2 h-12 text-center border rounded-md shadow-sm  border-purple-700 ring-border-purple-700"  type="tel"  #otp2  formControlName="two"
                    (keyup)="moveFocus($event,otp3,otp1)" maxlength="1" pattern="[0-9]"   autocomplete="one-time-code" required>
            <input class="w-12 h-12 lg:m-2 text-center border rounded-md shadow-sm  border-purple-700 ring-border-purple-700"  type="tel"  #otp3  formControlName="three"
                    (keyup)="moveFocus($event,otp4,otp2)" maxlength="1" pattern="[0-9]"  autocomplete="one-time-code" required>
            <input class="w-12 h-12 lg:m-2 text-center border rounded-md shadow-sm  border-purple-700 ring-border-purple-700"  type="tel"  #otp4  formControlName="four"
                    (keyup)="moveFocus($event,otp5,otp3)" maxlength="1" pattern="[0-9]"  autocomplete="one-time-code" required>
            <input class="w-12 h-12 lg:m-2 text-center border rounded-md shadow-sm  border-purple-700 ring-border-purple-700"  type="tel"  #otp5  formControlName="five"
                    (keyup)="moveFocus($event,otp6,otp4)" maxlength="1" pattern="[0-9]"  autocomplete="one-time-code" required>
            <input class="w-12 h-12 lg:m-2 text-center border rounded-md shadow-sm  border-purple-700 ring-border-purple-700"  type="tel"  #otp6  formControlName="six"
                    (keyup)="moveFocus($event,'',otp5)" maxlength="1" pattern="[0-9]"  autocomplete="one-time-code" required>
        

    -->

   

  <!-- <div class="otp-verification-container">
    <h2>Enter OTP</h2>
    <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="otpConfig"></ng-otp-input>
    <button (click)="verifyOtp()">Verify OTP</button>
    <p *ngIf="verificationMessage">{{ verificationMessage }}</p>
  </div> -->


  

  
